import { Factory } from 'rosie';

import '../conversation_item_factory';
// CustomAttributeValueWithDefaults lives here. conversation_items/index.js
// doesn't pull it in, so this file has to declare the dependency itself or the
// standalone `make -C factories test` run can't resolve it.
import '../custom_attribute_factory';
import IdGenerator from '../lib/id_generator';

Factory.define('TaskCustomAttributeChange').attr('type', 'TASK_CUSTOM_ATTRIBUTE_CHANGE');

Factory.define('TaskCustomAttributeChangeWithDefaults')
  .extend('TaskCustomAttributeChange')
  .attr('taskId', IdGenerator.newId())
  .attr('added', () => [Factory.attributes('CustomAttributeValueWithDefaults', { id: 'addedId', value: 'addedValue' })])
  .attr('removed', () => [
    Factory.attributes('CustomAttributeValueWithDefaults', { id: 'removedId', value: 'removedValue' }),
  ]);

Factory.define('TaskCustomAttributeChangeItem')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('TaskCustomAttributeChange', content));

Factory.define('TaskCustomAttributeChangeItemWithDefaults')
  .extend('ConversationItemWithDefaults')
  .attr('content', ['content'], function (content) {
    return Factory.attributes('TaskCustomAttributeChangeWithDefaults', content);
  })
  .attr('initiator', {
    type: 'AGENT',
    id: IdGenerator.newId(),
  });

Factory.define('TaskCustomAttributeChangeItemWithAPIInitiator')
  .extend('ConversationItemWithDefaults')
  .attr('content', ['content'], function (content) {
    return Factory.attributes('TaskCustomAttributeChangeWithDefaults', content);
  })
  .attr('initiator', {
    type: 'API',
  });
